import React from 'react';
import { Container } from 'react-bootstrap';
import { Redirect } from "react-router-dom";
import Home from './Home';
import './Dashboard.css';

/**
 * Dashboard to edit or remove projects
 * login is required 
 */
class Dashboard extends React.Component {
    render() {
        const freeAccess = parseInt(process.env.REACT_APP_DASHBOARD_FREE_ACCESS);
        if (!this.props.user && !freeAccess)
            return <Redirect to='/login' />

        const user = freeAccess ? { username: "John Doe" } : this.props.user
        return (
            <Container className="dashboard">
                <div className="dashboard-header">
                    <span className="dashboard-title">Dashboard</span>
                    <div className="dashboard-user">
                        {/* <img className="dashboard-usericon" src={userImg} /> */}
                        <span className="dashboard-username">{user.username}</span>
                    </div>
                </div>
                <Home user={user} />
            </Container>
        )
    }
}

export default Dashboard;